
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const refundApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listRefunds: builder.query ({
      query: (params) => `v2/refund/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["Refund"]
    }),
    getRefund: builder.query ({
      query: (refund_id) => `v2/refund/${refund_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["Refund"]
    }),

    updateRefund: builder.mutation ({
      query: ({refund_id, data}) => ({
        url: `v2/refund/${refund_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["Refund"]
    }),
    deleteRefund: builder.mutation ({
      query: (refund_id) => ({
        url: `v2/refund/${refund_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["Refund"]
    }),
    createRefund: builder.mutation ({
      query: (data) => ({
        url: `v2/refund/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["Refund"]
    }),
  })
})


export const {
  useListRefundsQuery,
  useLazyListRefundsQuery,
  useGetRefundQuery,
  useLazyGetRefundQuery,

  useUpdateRefundMutation,
  useDeleteRefundMutation,
  useCreateRefundMutation
} = refundApi
